import { render, staticRenderFns } from "./UploadFile.vue?vue&type=template&id=7cf540ad&scoped=true"
import script from "./script?vue&type=script&lang=js&external"
export * from "./script?vue&type=script&lang=js&external"
import style0 from "./UploadFile.vue?vue&type=style&index=0&id=7cf540ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf540ad",
  null
  
)

export default component.exports